import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';

export const NawiMark = ({ size = 32 }) => (
  <img
    alt=""
    aria-hidden="true"
    className="nawi-chat__mark"
    height={size}
    src="/nawi_mark.svg"
    width={size}
  />
);

NawiMark.propTypes = {
  size: PropTypes.number,
};

export const LogoFull = ({ height = 38 }) => (
  <img
    alt="Nawi-GPT"
    className="nawi-chat__logo"
    src="/nawi_logo.svg"
    style={{ height }}
  />
);

LogoFull.propTypes = {
  height: PropTypes.number,
};

const NawiSpinner = ({ size = 120, speed = 'think' }) => (
  <div
    aria-hidden="true"
    className={`nawi-spinner nawi-spinner--${speed}`}
    style={{ height: size, width: size }}
  >
    <NawiMark size={size} />
  </div>
);

NawiSpinner.propTypes = {
  size: PropTypes.number,
  speed: PropTypes.oneOf(['fast', 'think']),
};

export const SpinnerOverlay = () => (
  <div
    aria-label={I18n.t('persons.nawiChat.authenticating')}
    className="spinner-overlay"
    role="status"
  >
    <NawiSpinner size={110} speed="fast" />
  </div>
);
